export const SET_ERRORS = 'PAPER_SET_ERRORS';

export function setErrors(errors, elementId) {
    return {
        type: SET_ERRORS,
        elementId,
        errors,
    };
};
